import { IRecipientCompliance } from '@nkr/models/index';
import { TableWrapperLeftAligned } from './styles';
import ReactHtmlParser from 'react-html-parser';

interface IProps {
    list: IRecipientCompliance[],
    centerId: number,
    isPostTxp: boolean
}

const RecipientCompliance = (props: IProps) => {
    const getLink = (id: number) => {
        if (props.isPostTxp) {
            return `center/${props.centerId}/recipient/${id}/profile/post-transplant`;
        }

        return `center/${props.centerId}/recipient/${id}/profile/general`;
    };

    return (
        <div style={{ height: 500, overflowY: 'scroll' }}>
            <TableWrapperLeftAligned className='table table-condensed table-striped table-bordered'>
                <thead>
                    <tr>
                        <th>Recipient</th>
                        <th>Item</th>
                    </tr>
                </thead>
                <tbody>
                    {props.list.map((item, index) =>
                        <tr key={index}>
                            <td><a href={getLink(item.id)} target='_blank'>{item.alias}</a></td>
                            <td>
                                {item.complianceIssues.map((issue, index) =>
                                    <div key={index}>{ReactHtmlParser(issue)}</div>
                                )}
                            </td>
                        </tr>
                    )}
                </tbody>
            </TableWrapperLeftAligned>
        </div>
    );
}

export default RecipientCompliance;